define([

], function () {
    "use strict";

    var nativeConsole,
        method,
        noop = function () {},
        methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
            'timeStamp', 'trace', 'warn'
        ],
        length = methods.length;

    nativeConsole = (window.console = window.console || {});

    while (length--) {
        method = methods[length];
        try {
            // Only stub undefined methods.
            if (!nativeConsole[method]) {
                nativeConsole[method] = noop;
            }
        } catch (e) {
            // nothing we can do
        }
    }

    return nativeConsole;
});
